<template>
  <b-nav tabs>
    <b-nav-item to="/">Home</b-nav-item>
    <b-nav-item to="/bac">Board &amp; Cards Games</b-nav-item>
    <b-nav-item to="/tabletop">Tabletop Games</b-nav-item>
    <b-nav-item to="/misc">Other Stuff</b-nav-item>
    <b-nav-item to="/about">About Us</b-nav-item>
    <b-nav-item to="/charity">Outreach</b-nav-item>
    <b-nav-item href="https://twitch.tv/xarknor" target="_blank">Streaming</b-nav-item>
    <b-nav-item href="https://gf.me/u/xpatgw" target="_blank">Donate</b-nav-item>
  </b-nav>
</template>
<script>
export default {
  name: "AppNav",
  data() {
    return {
      msg: "Welcome to Your Vue.js App - Cortex",
    };
  },
};
</script>
<style scoped>
</style>
